import { createFileRoute } from '@tanstack/react-router'
import { HandlerEvolutionPage } from '../../components/handler-evolution/HandlerEvolutionPage'

export const Route = createFileRoute('/dev/handler-evolution')({
  component: HandlerEvolutionPage,
})
